if (!customElements.get('cart-terms')) {
  class CartTerms extends HTMLElement {
    constructor() {
      super();
      this.cartTermsCheckbox = this.querySelector('.js-cart-terms-checkbox');
      this.form = document.getElementById(this.cartTermsCheckbox.getAttribute('form'));
      this.submitHandler = this.handleSubmit.bind(this);
      // START ACDC Custom Code | ECB-121: Use capture phase + click fallback to win listener race
      this.form.addEventListener('submit', this.submitHandler, true);
      // Also intercept the checkout button click as a backup, in case submit is bypassed
      this.checkoutClickHandler = this.handleCheckoutClick.bind(this);
      this.checkoutBtn = this.form.querySelector('button[name="checkout"]');
      if (this.checkoutBtn) {
        this.checkoutBtn.addEventListener('click', this.checkoutClickHandler, true);
      }
      // END ACDC Custom Code

      // START ACDC Custom Code | ECB-121: Inline T&C error message
      this.errorEl = this.form.querySelector('.js-cart-terms-error');
      this.changeHandler = this.hideError.bind(this);
      this.cartTermsCheckbox.addEventListener('change', this.changeHandler);
      // END ACDC Custom Code
    }

    disconnectedCallback() {
      this.form.removeEventListener('submit', this.submitHandler);
      // START ACDC Custom Code | ECB-121: Inline T&C error message
      if (this.cartTermsCheckbox && this.changeHandler) {
        this.cartTermsCheckbox.removeEventListener('change', this.changeHandler);
      }
      // END ACDC Custom Code
    }

    /**
     * Handles cart form submit
     * @param {object} evt - Event object.
     */
    handleSubmit(evt) {
      if (!this.cartTermsCheckbox.checked) {
        evt.preventDefault();
        evt.stopPropagation();
        // START ACDC Custom Code | ECB-121: Inline T&C error message (replaces alert())
        this.showError();
        // END ACDC Custom Code
      }
    }

    // START ACDC Custom Code | ECB-121: Click-phase backup interceptor
    handleCheckoutClick(evt) {
      if (!this.cartTermsCheckbox.checked) {
        evt.preventDefault();
        evt.stopImmediatePropagation();
        this.showError();
      }
    }
    // END ACDC Custom Code

    // START ACDC Custom Code | ECB-121: Inline T&C error message
    showError() {
      if (!this.errorEl) {
        // Fallback to legacy alert if no inline error element exists
        alert(theme.strings.cartTermsConfirmation); // eslint-disable-line
        return;
      }
      this.errorEl.classList.remove('hidden');
      this.errorEl.setAttribute('role', 'alert');
    }

    hideError() {
      if (this.errorEl) {
        this.errorEl.classList.add('hidden');
      }
    }
    // END ACDC Custom Code
  }
  customElements.define('cart-terms', CartTerms);
}
